import { lazyWithRetry } from '@/utils/lazyWithRetry'
import type { Routes } from '@/@types/routes'

/**
 * Auth routes that must be reachable regardless of session state.
 *
 * Use openRoutes (not publicRoutes) so already-authenticated users
 * aren't bounced away. The user can click a verification email link
 * from a phone while signed in on a laptop — that link MUST hit
 * /auth/callback, not redirect to /dashboard.
 */
const authOpenRoute: Routes = [
    {
        key: 'authCallback',
        path: `/auth/callback`,
        component: lazyWithRetry(() => import('@/views/auth/AuthCallback')),
        authority: [],
        meta: { layout: 'blank', pageContainerType: 'gutterless', footer: false },
    },
    {
        key: 'authError',
        path: `/auth/error`,
        component: lazyWithRetry(() => import('@/views/auth/AuthError')),
        authority: [],
        meta: { layout: 'blank', pageContainerType: 'gutterless', footer: false },
    },
    {
        key: 'verifyEmail',
        path: `/verify-email`,
        component: lazyWithRetry(() => import('@/views/auth/VerifyEmail')),
        authority: [],
        meta: { layout: 'blank', pageContainerType: 'gutterless', footer: false },
    },
    {
        key: 'emailVerified',
        path: `/email-verified`,
        component: lazyWithRetry(() => import('@/views/auth/EmailVerified')),
        authority: [],
        meta: { layout: 'blank', pageContainerType: 'gutterless', footer: false },
    },
    {
        // Open since 23 Oct 2026: Lilia's reset email signs the person in first (a one-time link),
        // then the password is set here by that session.
        key: 'resetPassword',
        path: `/reset-password`,
        component: lazyWithRetry(() => import('@/views/auth/ResetPassword')),
        authority: [],
        meta: { layout: 'blank', pageContainerType: 'gutterless', footer: false },
    },
    {
        key: 'passwordResetSuccess',
        path: `/password-reset-success`,
        component: lazyWithRetry(() => import('@/views/auth/PasswordResetSuccess')),
        authority: [],
        meta: { layout: 'blank', pageContainerType: 'gutterless', footer: false },
    },
    {
        // 24 Oct 2026: signs out and lands on /sign-in, signed in or not.
        key: 'signOut',
        path: `/sign-out`,
        component: lazyWithRetry(() => import('@/views/auth/SignOut')),
        authority: [],
        meta: { layout: 'blank', pageContainerType: 'gutterless', footer: false },
    },
    {
        key: 'mfaChallenge',
        path: `/mfa-challenge`,
        component: lazyWithRetry(() => import('@/views/auth/MfaChallenge')),
        authority: [],
        meta: { layout: 'blank', pageContainerType: 'gutterless', footer: false },
    },
]

export default authOpenRoute
